import React, {useEffect, useState} from "react";
import MyPageSidebar from "./MyPageSidebar";
import "../styles/OrderDetail.css";
import {useNavigate} from "react-router-dom"; // ✅ 수정된 CSS 파일 적용

const OrderDetail = () => {
    var navigate = useNavigate();
    const currentUrl = window.location.href;
    const orderId = currentUrl.split("/").pop();
    const [purchaseData, setPurchaseData] = useState({}); // ✅ 구매 상세 정보
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        // ✅ 주문 상세 데이터 조회
        const fetchOrderDetailInfo = async () => {
            try{
                const response = await fetch(`/api/purchase-detail?id=${orderId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    throw new Error("구매내역을 불러올 수 없습니다.");
                }
                const data = await response.json();

                // ✅ 구매 상세 정보 설정
                setPurchaseData(data.purchaseData);
            } catch (error) {
                console.error("구매내역 조회 실패:", error);
            } finally {
                setLoading(false);
            }

        };

        fetchOrderDetailInfo();
    }, []);

    // 상품 결제 상태 텍스트
    const getStatusText = (status) => {
        switch (status) {
            case "CONFIRM":
                return "구매 확정";
            case "COMPLETE":
                return "결제 완료";
            case "WAITING":
                return "입금 대기";
            case "CANCEL":
                return "결제 취소";
            default:
                return "미정";
        }
    };

    // ✅ 결제 수단
    const getPaymentMethod = (status) => {
        switch (status) {
            case "SIMPLE_PAY":
                return "간편 결제";
            case "CREDIT_CARD":
                return "카드 결제";
            case "NON_BANKBOOK":
                return "무통장 결제";
            default:
                return "미정";
        }
    };

    if (isLoading) return <p>로딩 중...</p>;

    return (
        <div className="order-detail-container">
            <MyPageSidebar />
            <div className="order-detail-content">
                <h2 className="order-detail-title">구매내역</h2>

                {/* ✅ 주문번호 & 결제일 정보 */}
                <div className="order-detail-info">
                    <p>
                        <span className={"order-detail-info-date"}>결제일자</span> {purchaseData.orderDate}
                        <span>주문번호</span> {purchaseData.orderNumber}
                    </p>
                </div>

                {/* ✅ 결제상품 박스 */}
                <h2 className="order-detail-subtitle">결제 상품</h2>
                <div className="order-detail-box">
                    <div className="order-detail-header">
                        <span className="order-detail-status">{getStatusText(purchaseData.orderStatus)}</span>
                        <a href="#" className="order-detail-link" onClick={() => navigate(`/products/${purchaseData.orderItems[0].itemId}`)}>문의하기 &gt;</a>
                    </div>
                    <div className="order-detail-product">
                        {/* ✅ 상품 이미지 */}
                        <div className="order-detail-image">
                            <img src="/images/icon/no_product.png" alt="상품 이미지" className="order-detail-product-image" />
                        </div>
                        <div className="order-detail-details">
                            <p className="order-detail-date">{purchaseData.orderDate} 결제</p>
                            {purchaseData && purchaseData.orderItems.length > 1 ? (
                                <p className={"order-detail-title"}>{purchaseData.orderItems[0].itemName} 외 {purchaseData.orderItems.length - 1}개</p>
                            ) : (
                                <p className="order-detail-title">{purchaseData.orderItems[0].itemName}</p>
                            )}
                            {purchaseData && purchaseData.orderItems.length > 1 ? (
                                <p className="order-detail-quantity">{purchaseData.orderItems[0].count}개 | {purchaseData.orderItems[0].subscriptionPeriod}개월 외 {purchaseData.orderItems.length - 1}개</p>
                                ) :
                                (
                                <p className="order-detail-quantity">{purchaseData.orderItems[0].count}개 | {purchaseData.orderItems[0].subscriptionPeriod}개월</p>
                            )}
                            <p className="order-detail-price">총 {purchaseData.totalPrice}원</p>
                        </div>
                    </div>
                </div>

                {/* ✅ 결제 정보 */}
                <div className="order-detail-payment-info">
                    <h3>결제정보</h3>
                    <table>
                        <tbody>
                        <tr>
                            <td>결제수단</td>
                            <td>{getPaymentMethod(purchaseData.paymentMethod)}</td>
                        </tr>
                        <tr>
                            <td>상품 금액</td>
                            <td>{purchaseData.totalCostPrice}원</td>
                        </tr>
                        <tr>
                            <td>쿠폰 및 상품 할인</td>
                            <td>{purchaseData.totalDiscountPrice - purchaseData.usePoint}원</td>
                        </tr>
                        <tr>
                            <td>포인트 할인</td>
                            <td>{purchaseData.usePoint}원</td>
                        </tr>
                        <tr>
                            <td>총 할인금액</td>
                            <td>{purchaseData.totalDiscountPrice}원</td>
                        </tr>
                        <tr className="order-detail-final-price">
                            <td>최종 결제금액</td>
                            <td>{purchaseData.totalPrice}원</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                {/* ✅ 포인트 적립 정보 */} {/* 수정 필요 */}
                <div className="order-detail-point-info">
                    <h3>포인트 적립</h3>
                    <table>
                        <tbody>
                        <tr>
                            <td>구매 적립 포인트</td>
                            <td>{purchaseData.accumulatePoint}P</td>
                        </tr>
                        <tr>
                            <td>리뷰 적립 포인트</td>
                            <td>{purchaseData.reviewPoint}P</td>
                        </tr>
                        <tr className="order-detail-final-point">
                            <td>최종 적립 포인트</td>
                            <td>{purchaseData.accumulatePoint + purchaseData.reviewPoint}P</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default OrderDetail;
